import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useTableExpandedRowsStore = create<{ [tableId: string]: unknown[] }>()(
  persist((_) => ({}), {
    name: 'table-expanded-rows-storage'
  })
)

export const setExpandedRowsTableStore = <T>(tableId: string, data: T[]) => {
  useTableExpandedRowsStore.setState((prevState) => ({ ...prevState, [tableId]: data }))
}

export const resetExpandedRowsTableStore = (tableId: string) => {
  useTableExpandedRowsStore.setState((prevState) => ({ ...prevState, [tableId]: [] }))
}

export const resetAllExpandedRowsTableStores = () => {
  useTableExpandedRowsStore.setState({}, true)
}
